import tooltipTemplates from './tooltipTemplates';

import {
  DefaultTooltip,
  WithIconsTooltip,
  WithFlagTooltip
} from './tooltipLayouts';

const tooltipsSet = [
  {
    component: DefaultTooltip,
    codeTemplate: tooltipTemplates.default,
    optionsGroup: [
      {
        label: 'Columns',
        options: [
          {label: 'Label, Title, Description', type: 'radio', options:{ __layout: 'default1'}},
          {label: 'Lists', type: 'radio', options:{ __layout: 'default2'}},
          {label: 'Title, Label, Item', type: 'radio', options:{ __layout: 'default3'}}
        ]
      },
      {
        label: 'Colour:',
        options: [
          {label: 'Black', type: 'radio', options:{whiteBackground: false, purpleBackground: false}},
          {label: 'Purple', type: 'radio', options:{whiteBackground: false, purpleBackground: true}},
          {label: 'White', type: 'radio', options:{whiteBackground: true, purpleBackground: false}}
        ]
      },
      {
        label: 'Layout',
        options: [
          {label: 'Placement', type: 'dropdown', selectList:[
            {label: 'top', value: 'top', options: {placement: 'top'}},
            {label: 'top-start', value: 'top-start', options: {placement: 'top-start'}},
            {label: 'top-end', value: 'top-end', options: {placement: 'top-end'}},
            {label: 'right', value: 'right', options: {placement: 'right'}},
            {label: 'right-start', value: 'right-start', options: {placement: 'right-start'}},
            {label: 'right-end', value: 'right-end', options: {placement: 'right-end'}},
            {label: 'bottom', value: 'bottom', options: {placement: 'bottom'}},
            {label: 'bottom-start', value: 'bottom-start', options: {placement: 'bottom-start'}},
            {label: 'bottom-end', value: 'bottom-end', options: {placement: 'bottom-end'}},
            {label: 'left', value: 'left', options: {placement: 'left'}},
            {label: 'left-start', value: 'left-start', options: {placement: 'left-start'}},
            {label: 'left-end', value: 'left-end', options: {placement: 'left-end'}}
          ]},
        ]
      }
    ]
  },
  {
    component: WithIconsTooltip,
    codeTemplate: tooltipTemplates.withIcon,
    optionsGroup: [
      {
        label: 'Icons',
        options: [
          {label: 'Trigger', type: 'radio', options:{ withCloseButton: true, __secondaryLayout: false}},
          {label: 'Map Points', type: 'radio', options:{ withCloseButton: false, __secondaryLayout: true}}
        ]
      },
      {
        label: 'Colour:',
        options: [
          {label: 'Black', type: 'radio', options:{whiteBackground: false, purpleBackground: false}},
          {label: 'Purple', type: 'radio', options:{whiteBackground: false, purpleBackground: true}},
          {label: 'White', type: 'radio', options:{whiteBackground: true, purpleBackground: false}}
        ]
      },
      {
        label: 'Layout',
        options: [
          {label: 'Placement', type: 'dropdown', selectList:[
            {label: 'top', value: 'top', options: {placement: 'top'}},
            {label: 'top-start', value: 'top-start', options: {placement: 'top-start'}},
            {label: 'top-end', value: 'top-end', options: {placement: 'top-end'}},
            {label: 'right', value: 'right', options: {placement: 'right'}},
            {label: 'right-start', value: 'right-start', options: {placement: 'right-start'}},
            {label: 'right-end', value: 'right-end', options: {placement: 'right-end'}},
            {label: 'bottom', value: 'bottom', options: {placement: 'bottom'}},
            {label: 'bottom-start', value: 'bottom-start', options: {placement: 'bottom-start'}},
            {label: 'bottom-end', value: 'bottom-end', options: {placement: 'bottom-end'}},
            {label: 'left', value: 'left', options: {placement: 'left'}},
            {label: 'left-start', value: 'left-start', options: {placement: 'left-start'}},
            {label: 'left-end', value: 'left-end', options: {placement: 'left-end'}}
          ]},
        ]
      }
    ]
  },
  {
    component: WithFlagTooltip,
    codeTemplate: tooltipTemplates.withFlag,
    optionsGroup: [
      {
        label: 'Flag',
        options: [
          {label: 'Flag Left', type: 'radio', options:{ __layout: 'left' }},
          {label: 'Flag Right', type: 'radio', options:{ __layout: 'right' }}
        ]
      },
      {
        label: 'Layout',
        options: [
          {label: 'Placement', type: 'dropdown', selectList:[
            {label: 'top', value: 'top', options: {placement: 'top'}},
            {label: 'top-start', value: 'top-start', options: {placement: 'top-start'}},
            {label: 'top-end', value: 'top-end', options: {placement: 'top-end'}},
            {label: 'right', value: 'right', options: {placement: 'right'}},
            {label: 'right-start', value: 'right-start', options: {placement: 'right-start'}},
            {label: 'right-end', value: 'right-end', options: {placement: 'right-end'}},
            {label: 'bottom', value: 'bottom', options: {placement: 'bottom'}},
            {label: 'bottom-start', value: 'bottom-start', options: {placement: 'bottom-start'}},
            {label: 'bottom-end', value: 'bottom-end', options: {placement: 'bottom-end'}},
            {label: 'left', value: 'left', options: {placement: 'left'}},
            {label: 'left-start', value: 'left-start', options: {placement: 'left-start'}},
            {label: 'left-end', value: 'left-end', options: {placement: 'left-end'}}
          ]},
        ]
      }
    ]
  }
];

export default tooltipsSet;


// WEBPACK FOOTER //
// ./src/containers/elements/Tooltips/constants/tooltipSet.js